import Panzoom from '@panzoom/panzoom';

export default function() {

  const mapHTML = `
    <div class="amp-map__directions map__directions">
      <div class="amp-map__directions-box map__directions-box">
        <img data-src="${FULLCLIENTTHEMEPATH}images/St-Josephs-Health-Amphitheater-Logo-Colorr.svg" class="lozad" alt="Amphitheater">
        <span>490 Restoration Way, <br>Syracuse, NY 13209</span>
        <a href="https://goo.gl/maps/KdW7vLdhUE3AyrNH9" target="_blank">Get Directions</a>
      </div>
    </div>
    <div class="amp-map map-inner">
      <div class="amp-map-top"></div>
      <div class="amp-map-wrapper map-wrapper">
        <img 
          data-src="${FULLCLIENTTHEMEPATH}images/am_map-centerr.png"
          class="amp-map__img-desktop map__img-desktop lozad" 
          alt="Amphitheater Map">
        <img 
          src="${FULLCLIENTTHEMEPATH}images/am_map-centerr-m.png"
          class="amp-map__img-mobile map__img-mobile" 
          alt="Amphitheater Map">       
        <div class="amp-map__controls">
        <div class="amp-map__controls-zoom">
          <div class="amp-map__zoomin map-btn" tabindex="0" aria-label="zoom in">
            <svg aria-hidden="true" data-prefix="fal" data-icon="plus" viewBox="0 0 384 512" class="svg-inline--fa fa-plus fa-w-12 fa-3x">
              <path fill="currentColor" d="M376 232H216V72c0-4.42-3.58-8-8-8h-32c-4.42 0-8 3.58-8 8v160H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h160v160c0 4.42 3.58 8 8 8h32c4.42 0 8-3.58 8-8V280h160c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"/>
            </svg>
          </div>
          <div class="amp-map__zoomout map-btn" tabindex="0" aria-label="zoom out">
            <svg aria-hidden="true" data-prefix="fal" data-icon="minus" viewBox="0 0 384 512" class="svg-inline--fa fa-minus fa-w-12 fa-3x">
              <path fill="currentColor" d="M376 232H8c-4.42 0-8 3.58-8 8v32c0 4.42 3.58 8 8 8h368c4.42 0 8-3.58 8-8v-32c0-4.42-3.58-8-8-8z"/>
            </svg>
          </div>
        </div>
          <a href="https://goo.gl/maps/KdW7vLdhUE3AyrNH9" target="_blank" class="map-btn">Get Directions</a>
        </div>
      </div>    
    </div>
  `;

  $('#amphitheater__map').append(mapHTML);
  $('#oncenter__map').remove();

  let panzoom;
  
  let initPanzoom = () => {
    
    const ampMap = document.querySelector('.amp-map__img-mobile');
    panzoom = Panzoom(ampMap, {
      maxScale: 5,
      contain: 'outside',
      startScale: 1
    });

    // Panning and pinch zooming are bound automatically (unless disablePan is true).
    // There are several available methods for zooming
    // that can be bound on button clicks or mousewheel.
    $('.amp-map__zoomin')[0].addEventListener('click', panzoom.zoomIn)
    $('.amp-map__zoomout')[0].addEventListener('click', panzoom.zoomOut)
    // elem.parentElement.addEventListener('wheel', panzoom.zoomWithWheel)

    initPanzoom.initialized = true;
  }

  if (window.innerWidth < 1000) {
    $(window).load(function() {
      initPanzoom();
    })
  }


  
  
  let resizeTimer;

  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
  
      if (this.innerWidth < 1000 && !initPanzoom.initialized) {
        initPanzoom();   
      } else if (this.innerWidth >= 1000 && initPanzoom.initialized){
        panzoom.destroy();
        initPanzoom.initialized = false;
      }
              
    }, 250);


  });

}